// @flow
import PitDashboard from './PitDashboard.container';

export default PitDashboard;
